import { Component, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';



@Injectable({
    providedIn: 'root',
})
export class CodiceBpService {
    constructor(private dialog: MatDialog) { }

    // Funzione per aprire il dialog dinamico
    openCodiceBPModal(): Observable<any> {
        const dialogRef = this.dialog.open(CodiceBPDialogComponent, {
            width: '400px',
            data: {}, 
        });

        return dialogRef.afterClosed(); 
    }
}

// Componente dinamico creato direttamente nel servizio
@Component({
    selector: 'app-codice-bp-dialog',
    template: `
    <h2 mat-dialog-title>{{'recordsManagement.approve.title' | transloco}}</h2>
    <form [formGroup]="codiceBpForm">
      <mat-form-field appearance="fill">
        <input matInput formControlName="codiceBP" />
        <mat-error *ngIf="codiceBpForm.get('codiceBP')?.invalid">Campo obbligatorio</mat-error>
      </mat-form-field>
    </form>
    <div mat-dialog-actions>
      <button mat-button class="cancel-button" (click)="onCancel()">{{'recordsManagement.approve.cancel' | transloco}}</button>
      <button mat-button class="save-button" (click)="onSave()" [disabled]="codiceBpForm.invalid">{{'recordsManagement.approve.save' | transloco}}</button>
    </div>
  `,
    styles: [`
      mat-form-field {
      width: 100%;
      }
      mat-dialog-actions {
      display: flex;
      justify-content: flex-end;
      }   
      button.cancel-button {
      background-color: red;
      color: white;
      }
      button.save-button {
      background-color: green;
      color: white;
      }
      button.cancel-button:hover, button.save-button:hover {
      opacity: 0.8;
      }
    `],
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        CommonModule,
        TranslocoModule
    ],
})
export class CodiceBPDialogComponent {
    codiceBpForm: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<CodiceBPDialogComponent>,
    ) {
        this.codiceBpForm = new FormGroup({
            codiceBP: new FormControl('', Validators.required),
        });
    }

    onSave(): void {
        if (this.codiceBpForm.valid) {
            this.dialogRef.close({ codiceBP: this.codiceBpForm.value.codiceBP });
        }
    }

    onCancel(): void {
        this.dialogRef.close(null); // Chiude senza restituire nulla se annullato
    }
}
